import React from "react";
import cssClass from "./ClinicRateCard.module.scss";

const ClinicRateCard = ({ title, priceFrom }) => {
  return (
    <div className={cssClass.clinicRateCard}>
      <h4>{title}</h4>
      <div className={cssClass.priceContainer}>
        <p className={cssClass.fromLabel}>From</p>
        <p className={cssClass.price}>{priceFrom}</p>
      </div>
    </div>
  );
};

export default ClinicRateCard;

// OLD COMPONENT WITH LIST AND CTA

// const ClinicRateCard = ({ title, priceFrom, detailsArray }) => {
//   return (
//     <div className={cssClass.clinicRateCard}>
//       <div>
//         <h3>{title}</h3>
//         <div className={cssClass.priceContainer}>
//           <p className={cssClass.fromLabel}>From</p>
//           <p className={cssClass.price}>{priceFrom}</p>
//         </div>
//         <div className={cssClass.separator} />
//         <ul className={cssClass.detailsList}>
//           {detailsArray.map((detail) => {
//             return <li key={detail}>{detail}</li>;
//           })}
//         </ul>
//       </div>
//       <ButtonLink className={cssClass.buttonLink} blackGhost to={"/"}>
//         Request information
//       </ButtonLink>
//     </div>
//   );
// };
